import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { retrieveRunRecords, updateRecordPage } from '../store/actions/run_records';
import ScrollableRecordsTable from './scrollable_records_table';
import FixedRecordsTable from './fixed_records_table';

export class RecordsTable extends React.Component {
  static propTypes = {
    currentPage: PropTypes.number.isRequired,
    retrieveRunRecords: PropTypes.func.isRequired,
    totalPages: PropTypes.number.isRequired,
    onUpdatePage: PropTypes.func.isRequired
  }

  handleUpdatePage(page) {
    const { onUpdatePage, retrieveRunRecords, totalPages } = this.props;
    if (page >= 1 && page <= totalPages) {
      onUpdatePage(page);
      retrieveRunRecords();
    }
  }

  renderPaginationOptions() {
    const { currentPage, totalPages } = this.props;

    const previousClass = currentPage > 1 ? "clickable" : "text-muted";
    const nextClass = currentPage != totalPages ? "pl-2 clickable" : "pl-2 text-muted";

    return (
      <div className="d-inline-flex mb-4">
        <div className={previousClass} onClick={() => this.handleUpdatePage(currentPage - 1)}>
          &lt; Prev |
        </div>
        <div className={nextClass} onClick={() => this.handleUpdatePage(currentPage + 1)}>
          Next &gt;
        </div>
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.renderPaginationOptions()}
        <div className="table-container">
          <FixedRecordsTable />
          <ScrollableRecordsTable />
        </div>
        {this.renderPaginationOptions()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  ...state.runRecords.meta,
});

const mapDispatchToProps = {
  onUpdatePage: updateRecordPage,
  retrieveRunRecords
};

export default connect(mapStateToProps, mapDispatchToProps)(RecordsTable);